import React from "react";

//material mui components
import { Typography, Button } from "@mui/material";

//config home
import { MOBILE } from "../config";

//hooks
import { useGlobalState } from "../../../Utilidades/useGlobalState";

//styles
import {
  styleBarMovil,
  modalesMensajesGenericos,
  StyleHome,
  StyleHomeHeader,
} from "../../Tool/Style";

export const ActionTitleAndButtons = ({
  titleOption = "",
  saveClick,
  cleanClick,
  CodigoVerificado = false,
  deviceIs = "DESKTOP",
}) => {
  const classesBarMovil = styleBarMovil();
  const { etiquetas } = useGlobalState();

  const paddingSize = deviceIs === MOBILE ? "7px" : "initial";

  return (
    <div>
      {deviceIs == MOBILE ? (
        <Typography
          style={{
            ...StyleHomeHeader.HeaderText,
            ...{
              fontSize: 20,
              paddingBottom: "15px",
              textAlign: "center",
              paddingLeft: paddingSize,
              paddingRight: paddingSize,
              marginLeft: 0,
            },
          }}
        >
          {titleOption}
        </Typography>
      ) : null}
      <div
        style={
          deviceIs == MOBILE
            ? {
                paddingLeft: "7px",
                paddingRight: "7px",
                display: "flex",
                justifyContent: "center",
                gap: "10px",
              }
            : StyleHome.DivSalvarLimpiar
        }
      >
        {deviceIs == MOBILE ? null : (
          <Typography variant="h6">{titleOption}</Typography>
        )}
        {deviceIs == MOBILE ? null : <div className={classesBarMovil.grow} />}
        <Button
          style={
            deviceIs == MOBILE
              ? {
                  width: deviceIs == MOBILE ? "47.5%" : "initial",
                  backgroundColor: "#EDF0F4",
                }
              : modalesMensajesGenericos.BotonesNo
          }
          disabled={CodigoVerificado === false}
          onClick={cleanClick}
        >
          {etiquetas.General.Et_tbnLimpiar}
        </Button>
        <Button
          style={
            deviceIs == MOBILE
              ? {
                  width: deviceIs == MOBILE ? "47.5%" : "initial",
                  backgroundColor: "#082478",
                  color: "#fff",
                }
              : modalesMensajesGenericos.BotonesOk
          }
          disabled={CodigoVerificado === false && Boolean(saveClick)}
          onClick={saveClick}
        >
          {etiquetas.General.Et_tbnGuardar}
        </Button>
      </div>
    </div>
  );
};
